import React from "react";

interface DragIconProps {
  className?: string;
  size?: number;
}

const DragIcon: React.FC<DragIconProps> = ({ className = "", size = 14 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.24984 7.58366C5.572 7.58366 5.83317 7.32249 5.83317 7.00033C5.83317 6.67816 5.572 6.41699 5.24984 6.41699C4.92767 6.41699 4.6665 6.67816 4.6665 7.00033C4.6665 7.32249 4.92767 7.58366 5.24984 7.58366Z"
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.24984 3.49967C5.572 3.49967 5.83317 3.23851 5.83317 2.91634C5.83317 2.59418 5.572 2.33301 5.24984 2.33301C4.92767 2.33301 4.6665 2.59418 4.6665 2.91634C4.6665 3.23851 4.92767 3.49967 5.24984 3.49967Z"
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.24984 11.6667C5.572 11.6667 5.83317 11.4055 5.83317 11.0833C5.83317 10.7612 5.572 10.5 5.24984 10.5C4.92767 10.5 4.6665 10.7612 4.6665 11.0833C4.6665 11.4055 4.92767 11.6667 5.24984 11.6667Z"
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74984 7.58366C9.072 7.58366 9.33317 7.32249 9.33317 7.00033C9.33317 6.67816 9.072 6.41699 8.74984 6.41699C8.42767 6.41699 8.1665 6.67816 8.1665 7.00033C8.1665 7.32249 8.42767 7.58366 8.74984 7.58366Z"
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74984 3.49967C9.072 3.49967 9.33317 3.23851 9.33317 2.91634C9.33317 2.59418 9.072 2.33301 8.74984 2.33301C8.42767 2.33301 8.1665 2.59418 8.1665 2.91634C8.1665 3.23851 8.42767 3.49967 8.74984 3.49967Z"
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74984 11.6667C9.072 11.6667 9.33317 11.4055 9.33317 11.0833C9.33317 10.7612 9.072 10.5 8.74984 10.5C8.42767 10.5 8.1665 10.7612 8.1665 11.0833C8.1665 11.4055 8.42767 11.6667 8.74984 11.6667Z"
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DragIcon;
